import adapter from 'webrtc-adapter'
import Janus from 'janus-gateway'

if (typeof window !== 'undefined' && !window.adapter) {
	window.adapter = adapter
}

export default Janus
